export default __webpack_public_path__ + "static/media/deleteEnable.d1238896.svg";